import { render, staticRenderFns } from "./homeInheritorItem.vue?vue&type=template&id=1b8281be&scoped=true&"
import script from "./homeInheritorItem.vue?vue&type=script&lang=js&"
export * from "./homeInheritorItem.vue?vue&type=script&lang=js&"
import style0 from "./homeInheritorItem.vue?vue&type=style&index=0&id=1b8281be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8281be",
  null
  
)

export default component.exports